import i18n from "i18next";
import * as yup from "yup";

export const initializeYup = (yup) => {
  yup.setLocale({
    string: {
      email: i18n.t("validation.field.email.bad.format"),
      matches: i18n.t("validation.field.invalid"),
    },
    mixed: {
      default: i18n.t("validation.field.invalid"),
      required: i18n.t("validation.field.required"),
    },
    array: {
      min: i18n.t("validation.field.required"),
    },
  });
};

function isArraySchema(schema: yup.AnySchema): schema is yup.ArraySchema<any> {
  return schema?.type === "array";
}

export function createFormalValidationFromSchema<T extends yup.AnyObjectSchema>(schemaFactory: () => T): () => T {
  function createFormalValidation(schema: yup.AnySchema): yup.AnySchema {
    if (schema instanceof yup.ObjectSchema) {
      const newShape: Record<string, yup.AnySchema> = {};
      for (const key in schema.fields) {
        newShape[key] = createFormalValidation(schema.fields[key]);
      }
      return yup.object(newShape);
    }

    if (isArraySchema(schema)) {
      const cloned: any = schema.clone();
      if (cloned.tests.length === 0 && cloned.innerType) {
        cloned.innerType = createFormalValidation(cloned.innerType);
      }
      cloned.tests = cloned.tests.filter((test: any) => {
        const name = test.OPTIONS?.name;
        const isMinConstraint = name === "min" && test.OPTIONS?.params?.min === 1;
        return !isMinConstraint;
      });
      return cloned.optional();
    }

    if ("tests" in schema && Array.isArray((schema as any).tests)) {
      const cloned: any = schema.clone();
      cloned.tests = cloned.tests.filter((test: any) => {
        return test.OPTIONS?.name !== "required";
      });
      return cloned.optional?.() || cloned;
    }

    return schema.optional?.() || schema;
  }

  return function formalValidationSchemaFactory(): T {
    const original = schemaFactory();
    return createFormalValidation(original) as T;
  };
}
